import { API_BASE_URL, getHeaders, handleResponse } from '../apiConfig';

export const fetchClusters = async (academicYearId, params = {}) => {
  const query = new URLSearchParams();
  if (academicYearId) {
    query.append('academic_year_id', academicYearId);
  }
  if (params && typeof params === 'object') {
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        query.append(key, params[key]);
      }
    });
  }
  const queryString = query.toString() ? `?${query.toString()}` : '';
  const response = await fetch(`${API_BASE_URL}/clusters${queryString}`, {
    headers: getHeaders()
  });
  return handleResponse(response);
};


export const createCluster = async (data) => {
  const response = await fetch(`${API_BASE_URL}/clusters`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return handleResponse(response);
};

export const updateCluster = async (id, data) => {
  const response = await fetch(`${API_BASE_URL}/clusters/${id}`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return handleResponse(response);
};

export const deleteCluster = async (id) => {
  const response = await fetch(`${API_BASE_URL}/clusters/${id}`, {
    method: 'DELETE',
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const copyClustersToAcademicYear = async (data) => {
  const response = await fetch(`${API_BASE_URL}/clusters/copy`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return handleResponse(response);
};

export const fetchClusterInstitutions = async (clusterId, academicYearId) => {
  let url = `${API_BASE_URL}/clusters/${clusterId}/institutions`;
  if (academicYearId) {
    url += `?academic_year_id=${academicYearId}`;
  }
  const response = await fetch(url, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const createClusterInstitution = async (data) => {
  const response = await fetch(`${API_BASE_URL}/cluster-institutions`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return handleResponse(response);
};

export const updateClusterInstitution = async (id, data) => {
  const response = await fetch(`${API_BASE_URL}/cluster-institutions/${id}`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return handleResponse(response);
};

export const deleteClusterInstitution = async (id) => {
  const response = await fetch(`${API_BASE_URL}/cluster-institutions/${id}`, {
    method: 'DELETE',
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const saveClusterInstitutionStandardStrength = async (id, data) => {
  const response = await fetch(`${API_BASE_URL}/cluster-institutions/${id}/standard-strength`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return handleResponse(response);
};

export const fetchClusterAccess = async (clusterId) => {
  const response = await fetch(`${API_BASE_URL}/clusters/${clusterId}/access`, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const grantClusterAccess = async (clusterId, data) => {
  const response = await fetch(`${API_BASE_URL}/clusters/${clusterId}/access`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return handleResponse(response);
};

export const revokeClusterAccess = async (accessId) => {
  const response = await fetch(`${API_BASE_URL}/clusters/access/${accessId}`, {
    method: 'DELETE',
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const fetchStudioLogins = async () => {
  const response = await fetch(`${API_BASE_URL}/clusters/studio-logins`, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const fetchAllClusterStandards = async (academicYearId) => {
  let url = `${API_BASE_URL}/cluster-standards`;
  if (academicYearId) {
    url += `?academic_year_id=${academicYearId}`;
  }
  const response = await fetch(url, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const fetchClusterStandards = async (clusterId, academicYearId) => {
  let url = `${API_BASE_URL}/clusters/${clusterId}/standards`;
  if (academicYearId) {
    url += `?academic_year_id=${academicYearId}`;
  }
  const response = await fetch(url, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const createClusterStandard = async (data) => {
  const response = await fetch(`${API_BASE_URL}/cluster-standards`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return handleResponse(response);
};

export const updateClusterStandard = async (id, data) => {
  const response = await fetch(`${API_BASE_URL}/cluster-standards/${id}`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return handleResponse(response);
};

export const deleteClusterStandard = async (id) => {
  const response = await fetch(`${API_BASE_URL}/cluster-standards/${id}`, {
    method: 'DELETE',
    headers: getHeaders()
  });
  return handleResponse(response);
};

